import React from 'react';
import styles from './TableTopHeader.module.css';
import plus from '../../../assets/Imagess/plusvector.svg';
import SearchInput from '../../Atoms/Inputs/SearchInput';
import Buttons from '../../Atoms/Buttons/Buttons';

const TableTopHeader = ({
  add,
  handleOnAdd,
  user,
  mode,
  selected,
  isApplicant,
  setShowStatusModal,
  setShowEmailModal,
  setProgram,
  setStatus,
  setFieldOfInterest,
  search,
  setSearch,
  refetch,
  handleExport,
  disableControls,
  addLabel,
  rowsCount = 0,
  setDeleteMode,
  selectedUser,
  refetchUsers,
  type,
  padding = '',
}) => {
  const handleSearch = (e) => {
    // if (e.keyCode === 13) {
    //   setSearch(e.target.value);
    // }
    setSearch(e);
  };

  return (
    <div className={styles['icon-container']} style={{ padding: padding }}>
      <div>
        <SearchInput search={search} setSearch={handleSearch} />
      </div>

      <div className={styles['icon-subcontainer']}>
        <>
          <Buttons
            text={type === 0 || type === 2 ? 'رفع المجلة' : 'إنشاء الإرشادات'}
            icon={plus}
            iconWidth="18"
            iconHeight="18"
            rounded={true}
            color="rgba(13, 160, 110, 1)"
            handleOnClick={handleOnAdd}
            style={{
              marginTop: '12px',
              fontSize: '18px',
              fontFamily: 'BukraBold',
            }}
          />
        </>
      </div>
    </div>
  );
};

export default TableTopHeader;
